import { render, staticRenderFns } from "./ContiRicavi.vue?vue&type=template&id=4b647d82&"
import script from "./ContiRicavi.vue?vue&type=script&lang=ts&"
export * from "./ContiRicavi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports